// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__13lUL","logo":"styles_logo__3XWNb"};